export function filterMembers() {
  let filters = document.querySelectorAll('.team-member-filters-container input');

  filters.forEach(function(filter) {
    filter.addEventListener('change', function() {
      let filter_id = filter.id;
      hideCards(filter_id);
    })
  })

  function hideCards(id) {
    //console.log(id);
    const team_members_container = document.querySelector('ul.team-members');
    const team_members_children = team_members_container.children;
    const team_members_children_arr = Object.values(team_members_children);

    team_members_children_arr.forEach(function(child) {
      if(child.classList.contains(id)) {
        child.classList.add('active');
        child.classList.remove('hide');
        //child.classList.toggle('hide');
        if(child.classList.contains('active')) {
          child.style.display = "block";
        }
      } else if(!child.classList.contains(id)) {
        child.classList.add('hide');
        //child.classList.toggle('hide');
        child.classList.remove('active');
      }
    })
  }
}